<template>
	<div class="main" ref="main">
		<SideMenu />
        <!-- {{ getSideMenu }} -->

		<div v-if="mobile" class="student-menu-mobile" :class="{ 'opened': mobileMenu }">
			<ul>
				<li @click="viewBlock !== 1 ? system(responseDataGetTreeView, 1) : ''; toggleMobileMenu();">
					<div class="section-item" :class="viewBlock === 1 ? 'selected' : ''">
						<img class="section-icon" src="@/assets/img/system-organizm.png" />
						<div class="section-name">
							Системы организма
						</div>
					</div>
					
				</li>
				<li @click="somaticStatus(level, 2); toggleMobileMenu();">
					<div class="section-item" :class="viewBlock === 2 ? 'selected' : ''">
						<img class="section-icon" src="@/assets/img/som-status.png">
						<div class="section-name">
							Соматический статус
						</div>
					</div>
				</li>
				<li @click="physic(3); toggleMobileMenu();">
					<div class="section-item" :class="viewBlock === 3 ? 'selected' : ''">
						<img class="section-icon" src="@/assets/img/physic.png">
						<div class="section-name">
							Психические функции
						</div>
					</div>
				</li>
				<li>
					<div @click="startTest(4); toggleMobileMenu();" class="section-item" :class="viewBlock === 4 ? 'selected' : ''">
						<img class="section-icon" src="@/assets/img/tests_icon.png">
						<div class="section-name">
							Тесты
						</div>
					</div>
				</li>
			</ul>
		</div>

		<div class="main-content">
			<!-- <Header :title="currentPageName" :arrow="level > 1" /> -->
			<!-- <div class="header-invisible-back"></div> -->

            <!-- :style="getSideMenu ? 'width: calc(80% - 230px)' : 'width: calc(80% - 60px)'" -->
			<div
                class="header header__blue"
                v-if="viewBlock === 1 || mobile"
            >
				<v-row class="header-row">
                    <v-col
                        v-if="level !== 1"
                        xs="auto"
                        sm="auto"
                        style="max-width: 96px"
                        md="1"
                    >
                        <v-speed-dial
							v-if="!mobile"
							class="speed-dial-desktop"
							v-model="fab"
							direction="bottom"
							transition="scale-transition"
							>
							<template v-slot:activator>
								<v-btn v-model="fab" color="blue darken-4" dark fab>
								<v-icon v-if="fab"> mdi-close </v-icon>
								<v-icon v-else>mdi-format-list-bulleted-square</v-icon>
								</v-btn>
							</template>

							<v-btn
								v-if="level > 2"
								@click="handler(-1)"
								dark
								small
								color="green"
							>
								На уровень выше
							</v-btn>

							<v-btn
								v-if="level > 2"
								@click="handler(2)"
								dark
								small
								color="indigo"
							>
								к началу просмотра системы
							</v-btn>

							<v-btn @click="handler(1)" dark small color="red">
								к выбору системы
							</v-btn>
                        </v-speed-dial>
                    </v-col>

                    <v-col
                        :xs="level == 1 ? 12 : 10"
                        :sm="level == 1 ? 12 : 10"
                        :md="level == 1 ? 12 : 10"
                        class="ml-0 mr-0 pl-0 pr-0"
                        align-self="center"
                    >
                        <div
                        class="header__text"
                        :style="`padding-left:${level == 1 ? cx-(plText/2) : cx-96-(plText/2)}px`"
                        >
                            <span id="widthText">{{ currentPageName }}</span>
                        </div>
                    </v-col>
				</v-row>

				<v-row class="header-row-mobile">
					<v-col
						class="burger"
						xs="auto"
                        sm="auto"
						style="max-width: 48px"
						md="1"
						@click.prevent="toggleMobileMenu()"
					>
						<svg data-v-4e59dcd0="" width="25" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" class="">
							<rect data-v-4e59dcd0="" width="25" height="3" rx="2" fill="#FFF"></rect>
							<rect data-v-4e59dcd0="" y="8" width="25" height="3" rx="2" fill="#FFF"></rect>
							<rect data-v-4e59dcd0="" y="16" width="25" height="3" rx="2" fill="#FFF"></rect>
						</svg>
					</v-col>

					<v-col
						xs="10"
                        sm="10"
                        md="10"
                        class="ml-0 mr-0 pl-0 pr-0"
                        align-self="center"
                    >
                        <div v-if="viewBlock === 1" class="header__text">{{ currentPageName }}</div>
						<div v-else-if="viewBlock === 4" class="header__text">Тесты</div>
                    </v-col>
				</v-row>
			</div>

            <div class="block-split">
                <div class="block-div">
                    <div v-show="viewBlock === 1">
                        <svg id="svgElem" ref="svgEl">
                            <defs>
                                <linearGradient id="g" y1="100%" x2="100%">
                                    <stop offset="0%" stop-color="#5594f3" />
                                    <stop offset="100%" stop-color="#91cafb" />
                                </linearGradient>

                                <!-- Код для обрезки фото -->
                                <clipPath  patternUnits="userSpaceOnUse" id="clip">
                                    <circle :cx="cx" :cy="cy" :r="radiusClipPath" />
                                </clipPath>

                                <!-- Для обрезки центрального круга верхнего -->
                                <!-- <clipPath  patternUnits="userSpaceOnUse" id="cut-of-top">
                                    <rect :x="cx/2-200" :y="cy/2-100" width="100%" :height="cy/2+100" />
                                </clipPath> -->
                                
                                <!-- Для обрезки центрального круга нижнего -->
                                <!-- <clipPath  patternUnits="userSpaceOnUse" id="cut-of-bottom">
                                    <rect :x="cx/2-200" :y="cy" width="100%" :height="cy" />
                                </clipPath> -->
                            </defs>
                        </svg>

						<v-speed-dial
							v-if="mobile && level !== 1 && !mobileMenu"
							class="speed-dial-mobile"
							v-model="fab"
							direction="bottom"
							transition="scale-transition"
							:style="`left: ${clientW - 56 - 20}px;`"
							>
							<template v-slot:activator>
								<v-btn v-model="fab" color="blue darken-4" dark fab>
								<v-icon v-if="fab"> mdi-close </v-icon>
								<v-icon v-else>mdi-format-list-bulleted-square</v-icon>
								</v-btn>
							</template>

							<v-btn
								v-if="level > 2"
								@click="handler(-1)"
								dark
								small
								color="green"
							>
								На уровень выше
							</v-btn>

							<v-btn
								v-if="level > 2"
								@click="handler(2)"
								dark
								small
								color="indigo"
							>
								к началу просмотра системы
							</v-btn>

							<v-btn @click="handler(1)" dark small color="red">
								к выбору системы
							</v-btn>
                        </v-speed-dial>
                    </div>

                    <div v-show="viewBlock === 2">
                        <v-card :height="`${clientH}px`">
                            <v-toolbar style="border-top-left-radius: 0px; border-top-right-radius: 0px" dark color="#001e46" :dense="mobile">
                                <v-toolbar-title style="color: rgba(129, 182, 228, 0.95)">
                                    Показатели соматического статуса
                                </v-toolbar-title>
                            </v-toolbar>

                            <v-card-text>
                                <tree-views
                                    v-if="viewBlock === 2"
                                    :apiImg="apiImg"
                                    :humanInfo="human"
                                    :treeListM="filterPsychicFunctions(maleTreeView, 'notEqual')"
                                    :treeListJ="filterPsychicFunctions(femaleTreeView, 'notEqual')"
                                    :dialogSomaticName="dialogSomaticName"
									:mobile="mobile"
                                />
                            </v-card-text>

                        </v-card>
                    </div>

                    <div v-show="viewBlock === 3">
                        <v-card :height="`${clientH}px`">
                            <v-toolbar style="border-top-left-radius: 0px; border-top-right-radius: 0px" dark color="#001e46">
                                <v-toolbar-title style="color: rgba(129, 182, 228, 0.95)">
                                    Психические функции
                                </v-toolbar-title>
                            </v-toolbar>

                            <v-card-text class="mt-2">
                                <tree-views-physic
                                    v-if="viewBlock === 3"
                                    :apiImg="apiImg"
                                    :humanInfo="human"
                                    :treeListM="filterPsychicFunctions(maleTreeView, 'equal')"
                                    :treeListJ="filterPsychicFunctions(femaleTreeView, 'equal')"
                                    :dialogSomaticName="dialogSomaticName"
									:mobile="mobile"
                                />
                            </v-card-text>

                        </v-card>
                    </div>
                    
                    <div v-if="viewBlock === 4">
                        <v-toolbar v-if="!mobile" style="border-top-left-radius: 0px; border-top-right-radius: 0px" dark color="#001e46">
                            <v-toolbar-title style="color: rgba(129, 182, 228, 0.95)">
                                Тесты
                            </v-toolbar-title>
                        </v-toolbar>

                        <Tests :clientH="clientH"/>
                    </div>
                </div>

                <div class="three-btn">
                    <div
                        @click="viewBlock !== 1 ? system(responseDataGetTreeView, 1) : ''"
                        class="height-btn-metodist height-btn-split-m"
                        :class="{ 'activeBtn': viewBlock === 1 }"
                    >
                        <!-- :class="{
                            'height-btn-guest': userRoles === 'Student',
                            'height-btn-metodist': userRoles !== 'Student',
                            'activeBtn': viewBlock === 1,
                            'height-btn-split-m': viewBlock !== 1 && userRoles !== 'Student',
                            'height-btn-split-g': viewBlock !== 1 && userRoles === 'Student'
                        }" -->
                        <div class="btn-split-img">
                            <img src="@/assets/img/system-organizm.png" height="75%">
                        </div>
                        <div class="btn-split-header">
                            Системы организма
                        </div>
                    </div>
                    <div
                        @click="somaticStatus(level, 2)"
                        class="height-btn-metodist height-btn-split-m"
                        :class="{ 'activeBtn': viewBlock === 2 }"
                    >
                        <!-- :class="{
                            'height-btn-guest': userRoles === 'Student',
                            'height-btn-metodist': userRoles !== 'Student',
                            'activeBtn': viewBlock === 2,
                            'height-btn-split-m': viewBlock !== 2 && userRoles !== 'Student',
                            'height-btn-split-g': viewBlock !== 2 && userRoles === 'Student'
                        }" -->
                        <div class="btn-split-img">
                            <img src="@/assets/img/som-status.png" height="75%">
                        </div>
                        <div class="btn-split-header">
                            Соматический статус
                        </div>
                    </div>
                    <div
                        @click="physic(3)"
                        class="height-btn-metodist height-btn-split-m"
                        :class="{ 'activeBtn': viewBlock === 3 }"
                    >
                        <!-- :class="{
                            'height-btn-guest': userRoles === 'Student',
                            'height-btn-metodist': userRoles !== 'Student',
                            'activeBtn': viewBlock === 3,
                            'height-btn-split-m': viewBlock !== 3 && userRoles !== 'Student',
                            'height-btn-split-g': viewBlock !== 3 && userRoles === 'Student'
                        }" -->
                        <div class="btn-split-img">
                            <img src="@/assets/img/physic.png" height="75%">
                        </div>
                        <div class="btn-split-header">
                            Психические функции
                        </div>
                    </div>
                    <div
                        @click="startTest(4)"
                        class="height-btn-metodist height-btn-split-m"
                        :class="{ 'activeBtn': viewBlock === 4 }"
                    >
                        <!-- :class="{
                            'height-btn-guest': userRoles === 'Student',
                            'height-btn-metodist': userRoles !== 'Student',
                            'activeBtn': viewBlock === 4,
                            'height-btn-split-m': viewBlock !== 4 && userRoles !== 'Student',
                            'height-btn-split-g': viewBlock !== 4 && userRoles === 'Student'
                        }" -->
                        <div class="btn-split-img">
                            <img src="@/assets/img/tests_icon.png" height="75%">
                        </div>
                        <div class="btn-split-header">
                            Тесты
                        </div>
                    </div>
                </div>
            </div>
		</div>

		<!-- Общие сведения о системе и методика осмотра -->
		<v-dialog
			v-model="dialogSystems"
			width="500"
			fullscreen
			transition="dialog-bottom-transition"
		>
			<v-card>
				<v-toolbar dark color="#001e46">
				<v-toolbar-title style="color: rgba(129, 182, 228, 0.95)">
					{{ systemName }}
				</v-toolbar-title>
				<v-spacer></v-spacer>

				<v-toolbar-items>
					<!-- <v-btn color="rgba(129, 182, 228, 0.95)" dark text @click="dialogSystems = false" >Save</v-btn> -->
					<v-btn
					icon
					color="rgba(129, 182, 228, 0.95)"
					@click="dialogSystems = false"
					>
					<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar-items>
				</v-toolbar>

				<systems-components v-if="dialogSystems" :systemID="systemID" />
			</v-card>
		</v-dialog>
		
		<!-- Показатели соматического статуса -->
		<v-dialog v-model="dialogSomaticStatus" persistent width="1200" transition="dialog-bottom-transition" :loading="true">
			<v-card>
				<v-toolbar dark color="#001e46">
					<v-toolbar-title style="color: rgba(129, 182, 228, 0.95)">
						Показатели соматического статуса
					</v-toolbar-title>

					<v-spacer></v-spacer>

					<v-toolbar-items>
						<v-btn icon color="rgba(129, 182, 228, 0.95)" @click="dialogSomaticStatus = false" >
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-toolbar-items>
				</v-toolbar>

				<v-card-text class="mt-2">
					<tree-views
						v-if="dialogSomaticStatus"
						:apiImg="apiImg"
						:humanInfo="human"
						:treeListM="maleTreeView.properties"
						:treeListJ="femaleTreeView.properties"
						:dialogSomaticName="dialogSomaticName"
					/>
				</v-card-text>

			</v-card>
		</v-dialog>

		<v-bottom-sheet v-model="dialog">
			<v-sheet class="text-center" height="200px">
				<v-btn class="mt-6" text color="error" @click="dialog = !dialog"
				>Закрыть окно</v-btn
				>

				<div class="py-3">
				{{ currentTimerObj.name }}
				</div>
			</v-sheet>
		</v-bottom-sheet>
	</div>
</template>

<script>
// import Header from "@/components/Header/Header";
import SideMenu from "@/components/SideMenu/SideMenu";
import Snap from "snapsvg-cjs";
// import iconBack from "../assets/img/left-arrow.png";
import { mapActions, mapGetters, mapMutations } from "vuex";
import defaultIMG from "../../assets/img/defaultIMG.png";
import systemsComponents from "../Systems.vue";
// const mina = window.mina;
import treeViews from './treeViews.vue'
import treeViewsPhysic from './treeViewsPhysic.vue'
import Tests from './Tests/Tests.vue'

export default {
	name: "Student",
	components: { SideMenu, systemsComponents, treeViews, treeViewsPhysic, Tests },
	data: () => ({
        clientW: 960,
        clientH: 688,
        responseDataGetTreeView: null,
        viewBlock: 1,
		maleTreeView: {},
		femaleTreeView: {},
		human: {
			gender: null,
			ageFrom: null,
			ageTo: null,
			name: null
		},
		dialogSomaticStatus: false,
		dialogSomaticName: null,
		radiusClipPath: 0,
		plText: 0,
		fab: false,
		systemID: null,
		systemName: null,
		currentTimerObj: {
			name: "",
		},
		timer: 0,
		currentPageName: "",
		globalGroup: null,
		dialog: false,
		dialogSystems: false,
		g: null,
		gParse: null,
		groupG: null,
		r: null,
		cx: null,
		cy: null,
		x1: null,
		x2: null,
		y1: null,
		y2: null,
		cxText: null,
		descriptionLinkText: 'Перейти в описание',
		papers: null,
		imgs: [],
		a0: 0,
		lasta: 0,
		lastt: 0,
		lastv: 0,
		startDragTarget: null,
		level: 1,
		clickOrTapX: null,
		clickOrTapY: null,
		testClickOrTapX: null,
		testClickOrTapY: null,
		backArray: [],
		flagStatusBar: false,
		header: null,
		mobile: false,
		mobileMenu: false
	}),
	computed: {
		...mapGetters({
			apiUrl: "apiUrl",
			apiImg: "apiImg",
			userRoles: 'login/userRoles',
			gendersList: 'property/genders',
            getSideMenu: 'getSideMenu',
            getActivatedTest: 'tests/getActivatedTest'
		})
	},
	methods: {
		...mapActions({
			getGenders: 'property/getGenders'
		}),
		...mapMutations({
			setHeadList: "tree/setHeadList",
			resetNode: "tree/resetNode",
            changeActivatedTest: 'tests/changeActivatedTest'
		}),
		sector(cx, cy, r, startAngle, endAngle, rad) {
			this.x1 = parseFloat(cx + r * Math.cos(-startAngle * rad));
			this.x2 = parseFloat(cx + r * Math.cos(-endAngle * rad));
			this.y1 = parseFloat(cy + r * Math.sin(-startAngle * rad));
			this.y2 = parseFloat(cy + r * Math.sin(-endAngle * rad));

			var flag = endAngle - startAngle > 180 ? 1 : 0;

			var sectorpath = "M " + cx + " " + cy + " L" + this.x1 + " " + this.y1 + " A" + r + " " + r + " 0 " + flag + " 0 " + this.x2 + " " + this.y2 + "z";

			return this.g.path(sectorpath).attr({ fill: "none", class: "sectors", stroke: "none" });
		},
		img_path(x, y, text, obj, imageUrl, svgCircle, radius, flagDisabled) {
			let title, timerCounter;

			if (this.level == 1 || (obj.fullName && obj.fullName.length > 0)) {
				title = this.gParse(`<title>${this.level == 1 ? obj.name : obj.fullName}</title>`);
			}
			return this.g
				.g()
				.append(
					this.level == 1 && imageUrl.indexOf("files/icons") > -1
					?
					this.g.image(imageUrl, x - radius / 2, y - radius / 2 - 7,radius,radius)
						.attr({cursor: flagDisabled ? "pointer" : "default",display: `${this.level > 1 ? "none" : ""}`})
					: ""
				)
				.append(
					this.level == 1 && imageUrl.indexOf("files/icons") > -1
					?
					this.g.text(x, y + radius / 1.5, text)
						.attr({ fill: `rgba(129, 182, 228, 0.95)`, "text-anchor": "middle", "alignment-baseline": "middle", "font-size": `${radius / 2.5}px`, cursor: flagDisabled ? "pointer" : "default"})
					:
					this.createText( text, svgCircle.id, svgCircle.getBBox(), x, y, `${radius / 3.5}px`, flagDisabled)
				)
				.append(
					flagDisabled
					?
					""
					:
					this.g.circle(x, y, radius + 10)
						.attr({ fill: "rgba(0, 30, 70, 0.80)", cursor: flagDisabled ? "pointer" : "default"})
				)
				.append(this.level == 1 || (obj.fullName && obj.fullName.length > 0) ? title : "")
				.click((h) => {
					if(obj.isContentExist && !obj.isChildrenExist ) {
						this.systemID = obj.id;
						this.systemName = obj.name;
						this.setHeadList([]);
						this.resetNode()
						this.dialogSystems = true;

						return;
					}

					if((obj.isContentExist) || (obj.isChildrenExist) ) {
						if (h.x == this.clickOrTapX && h.y == this.clickOrTapY) {
							this.level += 1;

							this.globalGroup.animate({ transform: `s0 ${this.cx} ${this.cy}` }, 800, null, () => {
								this.globalGroup.clear();
								this.groupG.clear();
								this.papers.clear();

								this.renderGroup( obj.children, this.cx, this.cxText, this.cy, this.r, this.g, `${this.apiImg}${obj.imageUrl}`, obj.name, obj);
							})
						}

						this.spin();
					}
				})
				.touchstart((h) => {
					if(this.level == 1) {
						timerCounter = setInterval(() => {
						this.timer += 0.5;

						if(this.timer >= 1.5) {
							this.timer = 0;
							clearInterval(timerCounter);
							this.dialog = true;
							this.currentTimerObj = obj;
						}
						}, 500);
					}

					this.clickOrTapX = h.changedTouches[0].clientX;
					this.clickOrTapY = h.changedTouches[0].clientY;
				})
				.touchend((h) => {
					if(this.level == 1) {
						//если продержали меньше 1 секунд
						if (this.timer <= 1) {
							this.timer = 0;
							clearInterval(timerCounter);
						}
					}

					if(obj.isContentExist && !obj.isChildrenExist) {
						if ( h.changedTouches[0].clientX == this.clickOrTapX && h.changedTouches[0].clientY == this.clickOrTapY && !this.dialog ) {
							this.systemID = obj.id;
							this.systemName = obj.name;
							this.setHeadList([]);
							this.resetNode()
							this.dialogSystems = true;
						}

						return;
					}

					if((obj.isContentExist) || (obj.isChildrenExist)) {
						if(h.changedTouches[0].clientX == this.clickOrTapX && h.changedTouches[0].clientY == this.clickOrTapY && !this.dialog) {
							this.level += 1;

							this.globalGroup.animate({ transform: `s0 ${this.cx} ${this.cy}` }, 800, null, () => {
								this.globalGroup.clear();
								this.groupG.clear();
								this.papers.clear();

								this.renderGroup( obj.children, this.cx, this.cxText, this.cy, this.r, this.g, `${this.apiImg}${obj.imageUrl}`, obj.name, obj);
							})
						}

						this.spin();
					}
				});
		},
		startDrag(x, y, ev) {
			//Android / IOS
			if (typeof x == "object" && x.type == "touchstart") {
				x.preventDefault();

				this.clickOrTapX = x.changedTouches[0].clientX;
				this.clickOrTapY = x.changedTouches[0].clientY;

				this.startDragTarget = x.target;

				this.g.data("ot", this.g.transform().localMatrix);

				if (!this.g.data("startBBox")) {
				this.g.data("startBBox", this.g.getBBox());
				this.g.data("startScreenCTM", this.startDragTarget.getScreenCTM());
				}
				this.g.data("onDragStartFunc")();

				this.a0 = this.calcAngleByMousePos(x) - this.lasta;

				return;
			}

			this.clickOrTapX = x;
			this.clickOrTapY = y;

			this.startDragTarget = ev.target;

			this.g.data("ot", this.g.transform().localMatrix);

			if (!this.g.data("startBBox")) {
				this.g.data("startBBox", this.g.getBBox());
				this.g.data("startScreenCTM", this.startDragTarget.getScreenCTM());
			}
			this.g.data("onDragStartFunc")();

			this.a0 = this.calcAngleByMousePos(ev) - this.lasta;
		},
		moveDragKnob(dx, dy, x, y, ev) {
			let deg = this.calcAngleByMousePos(ev ? ev : dx) - this.a0,
				t = new Date(),
				v = 0;

			if (this.lastt != 0) v = (deg - this.lasta) / (t - this.lastt);
			this.lastt = t;
			this.lastv = v;
			this.lasta = deg;

			this.groupG.transform("r" + -deg + "," + this.cx + "," + this.cy);

			for (let i = 0; i < this.imgs.length; i++) {
				this.imgs[i].img.transform(
				"r" + deg + "," + this.imgs[i].mpx1 + "," + this.imgs[i].mpy1
				);
			}

			this.g.data("fracX", deg / 360);
		},
		calcAngleByMousePos(ev) {
			var pnt = this.startDragTarget.ownerSVGElement.createSVGPoint();

			pnt.x = ev.clientX ? ev.clientX : ev.changedTouches[0].clientX;
			pnt.y = ev.clientY ? ev.clientY : ev.changedTouches[0].clientY;

			var vPnt = pnt.matrixTransform(this.g.data("startScreenCTM").inverse());

			var deg =
				(Math.atan2(
				vPnt.x - this.g.data("startBBox").cx,
				vPnt.y - this.g.data("startBBox").cy
				) *
				180) /
				Math.PI;
			deg = deg + 180;

			return deg;
		},
		endDrag() {
			this.g.data("onDragEndFunc")();

			this.spin();
		},
		spin() {
			let da = 1;

			let s = setInterval(() => {
				this.lasta += this.lastv * da;
				da -= 0.01;

				if (da < 0) clearTimeout(s);

				this.groupG.transform(
				"r" + -this.lasta + "," + this.cx + "," + this.cy
				);

				for (let i = 0; i < this.imgs.length; i++) {
				this.imgs[i].img.transform(
					"r" + this.lasta + "," + this.imgs[i].mpx1 + "," + this.imgs[i].mpy1
				);
				}
			}, 10);
		},
		startAnimationStatusBar() {
			let elementArray = document.getElementsByClassName("status-bar");

			for (let i = 0; i < elementArray.length; i++) {
				elementArray[i].beginElement();
			}
		},
		handler(level) {
			let obj, indexElement;

			if (level == 1) {
                // console.log(this.level, this.backArray);
				obj = this.backArray.find((f) => f.level == 1);
				indexElement = this.backArray.findIndex((f) => f.level == 1);
			}

			if (level == 2) {
				obj = this.backArray.find((f) => f.level == 2);
				indexElement = this.backArray.findIndex((f) => f.level == 2);
			}

			if (level == -1) {
				obj = this.backArray.find((f) => f.level == this.level - 1);
				indexElement = this.backArray.findIndex((f) => f.level == this.level);
			}

			if (obj) {
				this.currentPageName = obj.text;

				if (level == 1) {
					this.level = 1;
					this.backArray.length = 1;
				} else if (level == 2) {
					this.level = 2;
					this.backArray.length = 2;
				} else {
					this.level -= 1;
					this.backArray.splice(indexElement, 1);
				}

                this.globalGroup.animate({ transform: `s0 ${this.cx} ${this.cy}` }, 800, null, () => {
					this.globalGroup.clear();
					this.groupG.clear();
					this.papers.clear();

					this.renderGroup(obj.array, obj.cx, obj.cxText, obj.cy, obj.r, obj.global, obj.imageUrl, obj.text, obj.obj, true)
				})

                // this.$nextTick(() => {
                //     this.g = Snap("#svgElem");
                //     this.papers = this.g.selectAll();
                //     this.papers.clear();

                //     console.log('this.renderGroup 1', this.backArray.find((f) => f.level == 1));

                //     this.renderGroup(obj.array, obj.cx, obj.cy, obj.r, obj.global, obj.imageUrl, obj.text, obj.obj, true)

                //     console.log('this.renderGroup 2');
                // })
			}
		},
		renderGroup(array, cx, cxText, cy, r, global, imageUrl, text, data, flagBack) {
			//записываем историю уровней что бы откатываться назад по 1му уровню
			if (!flagBack) this.backArray.push({ level: this.level, array, cx, cxText, cy, r, global, imageUrl, text, isContentExist: data.isContentExist, obj: data });

			let flagMobileOn = /Mobile|webOS|BlackBerry|IEMobile|MeeGo|mini|Fennec|Windows Phone|Android|iP(ad|od|hone)/i.test( navigator.userAgent );

			let circleLevelOne, circleTop, circleBottom;

			if(this.level == 1) {
				let circ = global
					.circle(cx, cy, r - 70)
					.attr({ fill: "rgba(36, 106, 169, 0.3)", stroke: "rgba(129, 182, 228, 0.95)", strokeWidth: 1, strokeDasharray: "7"});
				
				// let text = global
				// 	.text(cx, cy, "Показатели соматического статуса" )
				// 	.attr({ fill: "#FFFFFF", "font-family": "Roboto", "font-style": "normal", "font-weight": 600, "font-size": (r-70)/10, "line-height": "19px", "letter-spacing": "0.015em", "text-anchor": "middle", "alignment-baseline": "middle" })

				
				// Круг первого уровня
				circleLevelOne = global
					.g()
					// .append( text )
					.append( circ )
					// .mouseover( _ => {
					// 	circ.animate({ fill: "rgba(36, 106, 169, 0.4)" }, 300);
					// 	text.animate({ transform: `s${1.1} ${cx} ${cy}` }, 300)
					// })
					// .mouseout( _ => {
					// 	circ.animate({ fill: "rgba(36, 106, 169, 0.3)" }, 300);
					// 	text.animate({ transform: `s${1} ${cx} ${cy}` }, 300)
					// })
					// .click( _ => {
					// 	this.dialogSomaticName = null
					// 	this.dialogSomaticStatus = true
					// })

				// console.log(circleLevelOne)
			}

			if(this.level > 1) {
				let circTop = global
					.circle(cx, cy, r - 70)
					.attr({'clip-path': "url(#cut-of-top)", cursor: data.isContentExist ? "pointer": "default", fill: "rgba(36, 106, 169, 0.3)", stroke: "rgba(129, 182, 228, 0.95)", strokeWidth: 1, strokeDasharray: "7"}),
				textTop = global
                    // когда было разделено на 2 полукруга вместо cy использовалось = global.getBBox(circTop).cy-((global.getBBox(circTop).r1/2)-20)
					.text(cxText, cy, `${data.isContentExist ? this.descriptionLinkText : ''}` )
					.attr({ fill: "#FFFFFF", "font-family": "Roboto", "font-style": "normal", "font-weight": 600, "font-size": (r-70)/10, "line-height": "19px", "letter-spacing": "0.015em", "text-anchor": "middle", "alignment-baseline": "middle" });

				// let circBottom = global
				// 	.circle(cx, cy, r - 70)
				// 	.attr({'clip-path': "url(#cut-of-bottom)", cursor: "pointer", fill: "rgba(36, 106, 169, 0.3)", stroke: "rgba(129, 182, 228, 0.95)", strokeWidth: 1, strokeDasharray: "7"}),
				// 	textBottom = global
				// 		.text(cx, global.getBBox(circBottom).cy+((global.getBBox(circBottom).r1/2)-20), "Показатели системы" )
				// 		.attr({ fill: "#FFFFFF", "font-family": "Roboto", "font-style": "normal", "font-weight": 600, "font-size": (r-70)/10, "line-height": "19px", "letter-spacing": "0.015em", "text-anchor": "middle", "alignment-baseline": "middle" });

				// Круг уровня > 1 (верхняя половинка)
				circleTop = global
					.g()
					.append( textTop )
					.append( circTop )
					.mouseover( _ => {
						if(data.isContentExist) {
							circTop.animate({ fill: "rgba(36, 106, 169, 0.4)" }, 300);
							textTop.animate({ transform: `s${1.05} ${cx} ${global.getBBox(circTop).cy-((global.getBBox(circTop).r1/2)-20)}` }, 300)
						}
						// textBottom.animate({ transform: `s1 ${cx} ${global.getBBox(circBottom).cy+((global.getBBox(circBottom).r1/2)-20)}` }, 300)
					})
					.mouseout( _ => {
						if(data.isContentExist) {
							circTop.animate({ fill: "rgba(36, 106, 169, 0.3)" }, 300);
							textTop.animate({ transform: `s1 ${cx} ${global.getBBox(circTop).cy-((global.getBBox(circTop).r1/2)-20)}` }, 300)
						}
					})
					.click( _ => {
						if (data.isContentExist) {
							this.systemID = data.id;
							this.systemName = data.name;
							this.setHeadList([]);
							this.resetNode()
							this.dialogSystems = true;
						}
					})

				// Круг уровня > 1 (нижняя половинка)
				// circleBottom = global
				// 	.g()
				// 	.append( textBottom )
				// 	.append( circBottom )
				// 	.mouseover(h => {
				// 		circBottom.animate({ fill: "rgba(36, 106, 169, 0.4)" }, 300);
				// 		textBottom.animate({ transform: `s${1.1} ${cx} ${global.getBBox(circBottom).cy+((global.getBBox(circBottom).r1/2)-20)}` }, 300)
				// 		// textTop.animate({ transform: `s1 ${cx} ${global.getBBox(circTop).cy+((global.getBBox(circTop).r1/2)-20)}` }, 300)
				// 	})
				// 	.mouseout(h => {
				// 		circBottom.animate({ fill: "rgba(36, 106, 169, 0.3)" }, 300);
				// 		textBottom.animate({ transform: `s1 ${cx} ${global.getBBox(circBottom).cy+((global.getBBox(circBottom).r1/2)-20)}` }, 300)
				// 	})
				// 	.click((h) => {
				// 		if(this.level > 1) {
				// 			this.dialogSomaticName = this.backArray.find((f) => f.level == 2).text
				// 		}
				// 		this.dialogSomaticStatus = true
				// 	})
			}
			
			let circle1 = global
				.g()
				.append( this.level > 1 ? circleTop : '' )
				// .append( this.level > 1 ? circleBottom : '' )
				.append( this.level == 1 ? circleLevelOne : '' )

			this.radiusClipPath = r-70
			let circle2 = global
				.g()
				.append(
					global.image(
						imageUrl.indexOf(".png") == -1 ? defaultIMG : imageUrl,
						imageUrl.indexOf(".png") == -1 ? global.getBBox(circle1).x + (r - 70) / 2 : global.getBBox(circle1).x,
						imageUrl.indexOf(".png") == -1 ? global.getBBox(circle1).y + (r - 70) / 2 - 50 : global.getBBox(circle1).y,
						imageUrl.indexOf(".png") == -1 ? r - 70 : (r - 70) * 2,
						imageUrl.indexOf(".png") == -1 ? r - 70 + 100 : (r - 70) * 2
					).attr({'clip-path': "url(#clip)"})
				)
				.append(
					circle1
					.attr({ cursor: data.isContentExist ? "pointer" : "default" })
				);

			let circle3 = global.g().append(
				global.circle(cx, cy, r)
				.attr({ fill: "none", stroke: "rgba(129, 182, 228, 0.95)", strokeWidth: 2 })
			);

			let circle4 = global.g().append(
				global.circle(cx, cy, r + 70)
				.attr({fill: "none", stroke: "rgba(36, 106, 169, 0.5)", strokeWidth: 2, strokeDasharray: "7" })
			);

			this.currentPageName = text;

			var initial_angle = 0,
				n = array,
				da = 360 / n.length,
				rad = Math.PI / 180,
				sectors,
				circle;

			for (let i = 0; i < n.length; i++) {
				var end_angle = initial_angle + da;
				var sector_path = this.sector(cx, cy, r, initial_angle, end_angle, rad);

				var mpx1 = parseFloat( cx + r * Math.cos(-(initial_angle + da / 2) * rad) );
				var mpy1 = parseFloat( cy + r * Math.sin(-(initial_angle + da / 2) * rad) );

				let timerCounter;

				let flagDisabled = (n[i].isContentExist) || (n[i].isChildrenExist);

				let title;

				// console.log(n[i].fullName)

				if (this.level == 1 || (n[i].fullName && n[i].fullName.length > 0)) {
					title = this.gParse(`<title>${this.level == 1 ? n[i].name : n[i].fullName}</title>`);
				}

				// Circle
				circle = global
				.g()
				.append(
					global
					.circle(mpx1, mpy1, r / 5.5)
					.attr({ fill: "rgba(0, 30, 70, 1)", stroke: `rgba(129, 182, 228, ${ flagDisabled ? "0.95" : "0.25" })`, strokeWidth: 2, cursor: flagDisabled ? "pointer" : "default" })
					.click((h) => {
						if(n[i].isContentExist && !n[i].isChildrenExist ) {
							this.systemID = n[i].id;
							this.systemName = n[i].name;
							this.setHeadList([]);
							this.resetNode()
							this.dialogSystems = true;

							return;
						}

						if((n[i].isContentExist) || (n[i].isChildrenExist) ) {
							if (h.x == this.clickOrTapX && h.y == this.clickOrTapY) {
								this.level += 1;

								this.globalGroup.animate( { transform: `s0 ${cx} ${cy}` }, 800, null, () => {
									this.globalGroup.clear();
									this.groupG.clear();
									this.papers.clear();

									this.renderGroup(n[i].children, cx, cxText, cy, r, global, `${this.apiImg}${n[i].imageUrl}`, n[i].name, n[i]);
								});
							} else {
								this.spin();
							}
						}
					})
					.touchstart((h) => {
						if (this.level == 1) {
							timerCounter = setInterval(() => {
								this.timer += 0.5;

								if (this.timer >= 1.5) {
								this.timer = 0;
								clearInterval(timerCounter);
								this.dialog = true;
								this.currentTimerObj = n[i];
								}
							}, 500);
						}

						this.clickOrTapX = h.changedTouches[0].clientX;
						this.clickOrTapY = h.changedTouches[0].clientY;
					})
					.touchend((h) => {
						if (this.level == 1) {
							//если продержали меньше 1 секунды
							if (this.timer <= 1) {
								this.timer = 0;
								clearInterval(timerCounter);
							}
						}

						if (n[i].isContentExist && !n[i].isChildrenExist ) {
							if (h.changedTouches[0].clientX == this.clickOrTapX && h.changedTouches[0].clientY == this.clickOrTapY && !this.dialog ) {
								this.systemID = n[i].id;
								this.systemName = n[i].name;
								this.setHeadList([]);
								this.resetNode()
								this.dialogSystems = true;
							}

							return;
						}

						if((n[i].isContentExist) || (n[i].isChildrenExist) ) {
							if (h.changedTouches[0].clientX == this.clickOrTapX && h.changedTouches[0].clientY == this.clickOrTapY && !this.dialog ) {
								this.level += 1;

								this.globalGroup.animate({ transform: `s0 ${cx} ${cy}` }, 800, null, () => {
									this.globalGroup.clear();
									this.groupG.clear();
									this.papers.clear();

									this.renderGroup(n[i].children, cx, cxText, cy, r, global, `${this.apiImg}${n[i].imageUrl}`, n[i].name, n[i]);
								});
							}

							this.spin();
						}
					})
				)
				.append(this.level == 1 || (n[i].fullName && n[i].fullName.length > 0) ? title : "")
				.append(
					n[i].percentComplete > 0
					?
					this.gParse(`<path class="status-bar-transform" d="M${mpx1} ${ mpy1 - r / 5.5 }a${r / 5.5} ${ r / 5.5 } 0 1 0 1 0" fill="none" stroke-width="6" stroke-linecap="round" stroke="url(#g)" stroke-dashoffset="${ (6.28 * r) / 5.5 }" stroke-dasharray="${(6.28 * r) / 5.5}">
							<animate class="status-bar" id="an2" begin="indefinite" attributeName="stroke-dashoffset" dur="3s" values="${ (6.28 * r) / 5.5 };${((6.28 * r) / 5.5 / 100) * (100 - n[i].percentComplete) }" fill="freeze"/>
						</path>`)
					:
					""
				);

				let img = this.img_path( mpx1, mpy1, n[i].shortName ? n[i].shortName : n[i].name, n[i], `${this.apiImg}${n[i].iconUrl}`, circle, r / 7, flagDisabled );

				this.imgs.push({ mpx1, mpy1, img });

				sectors = global.group(sector_path, circle, img);

				this.papers.push(sectors);
				initial_angle = end_angle;
			}

			this.groupG = global.group(this.papers);

			global.data("onDragEndFunc", function () {});
			global.data("onDragStartFunc", function () {});

			//Проверка мобильное устройство это или нет
			if (flagMobileOn) {
				this.groupG.touchstart(this.startDrag);
				this.groupG.touchmove(this.moveDragKnob);
				this.groupG.touchend(this.endDrag);
			} else {
				this.groupG.drag(this.moveDragKnob, this.startDrag, this.endDrag);
			}

			this.globalGroup = global.group(circle2, circle3, circle4, this.groupG);

			this.globalGroup.animate({ transform: `s2 ${cx} ${cy}` }, 1, null, () => {
				this.globalGroup.animate({ transform: `s1 ${cx} ${cy}` }, 800, () => {

					//запуск анимации статус бара если это Студент
					if(this.userRoles.indexOf('Student') > -1) {
						this.startAnimationStatusBar(mpx1, mpy1 - r / 7)
					}
				});
			});

			// получаем ширину блока центрального текста
			this.$nextTick(() => {
				this.plText = document.getElementById('widthText').getBoundingClientRect().width
			})
		},
		createText(text, id, r, x, y, fontSize, flagDisabled) {
			var rows = text.split(/\n|-/);
			var t = this.g.text(x, y, "")
			.attr({
				"font-family": '"Roboto", arial, helvetica, verdana',
				"line-height": "normal",
				"font-size": fontSize,
				"font-stretch": "normal",
				"text-anchor": "middle",
				"font-style": "normal",
				"font-variant": "normal",
				"font-weight": 500,
			});

			for (var i = 0; i < rows.length; i++) {
				var row = rows[i];

				if (row == "") {
				rows.splice(i, 1);
				continue;
				}

				var spans = row.split(" ");
				var tmpRow = spans[0];
				for (var j = 1; j < spans.length; j++) {
					if (tmpRow != "") tmpRow += " ";
					tmpRow += spans[j];

					t.node.textContent = tmpRow;
					if (t.node.getBBox().width > r.width - 20) {
						rows[i] = "";
						for (var k = 0; k < j; k++) {
						if (rows[i] != "") rows[i] += " ";
						rows[i] += spans[k];
						}
						rows.splice(i + 1, 0, "");
						for (var k = j; k < spans.length; k++) {
						if (rows[i + 1] != "") rows[i + 1] += " ";
						rows[i + 1] += spans[k];
						}
						break;
					}
				}
			}

			t.remove();
			t = this.g.text(x, y, rows).attr({
				"font-family": '"Roboto", arial, helvetica, verdana',
				"line-height": "normal",
				"font-size": fontSize,
				"font-stretch": "normal",
				"text-anchor": "middle",
				"font-style": "normal",
				"font-variant": "normal",
				"font-weight": 500,
				objid: id,
			});
			var spans = t.selectAll("tspan");
			var cnt = spans.length;
			if (spans[0])
				spans[0].attr({
					x: x,
					dy: (-cnt / 2 + 0.8).toString() + "em",
					objid: id,
					fill: `rgba(129, 182, 228, 0.95)`,
					cursor: flagDisabled ? "pointer" : "default",
				});
			for (var i = 1; i < spans.length; i++)
				spans[i].attr({
				x: x,
				dy: "1em",
				objid: id,
				fill: `rgba(129, 182, 228, 0.95)`,
				cursor: flagDisabled ? "pointer" : "default",
				});

			// console.log(t)
			return t;
		},
        system(res, index) {
            if(this.getActivatedTest) {
                if(confirm('Вы уверены, что хотите выйти из теста? Ваши ответы не сохранятся!')) {
                    this.changeActivatedTest(false);
                    this.viewBlock = index;
                }
            } else {
                this.viewBlock = index;
            }
        },
        somaticStatus(level, index) {
            if(this.getActivatedTest) {
                if(confirm('Вы уверены, что хотите выйти из теста? Ваши ответы не сохранятся!')) {
                    this.changeActivatedTest(false);
                    if(level === 1) {
                        this.dialogSomaticName = null;
                    } else if(level > 1){
                        this.dialogSomaticName = this.backArray.find((f) => f.level == 2).text
                    }
                    this.viewBlock = index;
                }
            } else {
                if(level === 1) {
                    this.dialogSomaticName = null;
                } else if(level > 1){
                    this.dialogSomaticName = this.backArray.find((f) => f.level == 2).text
                }
                this.viewBlock = index;
            }
        },
        physic(index) {
            if(this.getActivatedTest) {
                if(confirm('Вы уверены, что хотите выйти из теста? Ваши ответы не сохранятся!')) {
                    this.changeActivatedTest(false);
                    this.viewBlock = index;
                }
            } else {
                this.viewBlock = index;
            }
        },
		getTreeView(data) {
			let treeView = {
				properties: data,
				psychicFunctionsId: null 
			}

			let psychicFunctions = treeView.properties.find((x) => x.name === 'Система психических функций');

			if (psychicFunctions !== undefined) {
				treeView.psychicFunctionsId = psychicFunctions.id;
			}

			return treeView;
		},
		filterPsychicFunctions(treeView, metod) {
            if(metod === 'notEqual') return treeView.properties.filter((f) => f.id !== treeView.psychicFunctionsId);
            if(metod === 'equal') return treeView.properties.filter((f) => f.id == treeView.psychicFunctionsId);
        },
		startTest(index) {
            this.viewBlock = index;
        },
		toggleMobileMenu() {
			this.mobileMenu = !this.mobileMenu;
		}
	},
	mounted() {
		this.g = Snap("#svgElem");
		this.gParse = Snap.parse;
		this.r = this.$refs.svgEl.clientHeight / 3;
		let mobileCenterOffsetX = 100;
		this.cx = this.clientW < 690 ? mobileCenterOffsetX : this.$refs.svgEl.clientWidth / 2;
		let smallRadius = this.r - 70;
		let mobileSvgOffsetX = window.document.documentElement.clientWidth * 0.2;	//css #svgElem left
		this.cxText = this.clientW < 690 ? (smallRadius * 2 - (smallRadius - mobileCenterOffsetX - mobileSvgOffsetX)) / 2 : this.$refs.svgEl.clientWidth / 2;
		this.cy = this.$refs.svgEl.clientHeight / 2 + 30;
		this.papers = this.g.selectAll();
		this.papers.clear();

		this.$http
		.get( `${this.apiUrl}BodyTree/GetTreeView?humanid=${this.$route.params.humanid}`)
		.then((res) => {
            console.log(res.data);

            this.responseDataGetTreeView = res;

			let topItem = res.data.find((x) => x.itemType === 0);

			this.renderGroup(topItem.children, this.cx, this.cxText, this.cy, this.r, this.g, `${this.apiImg}${topItem.imageUrl}`, topItem.name, topItem );
		});
	},
	async created() {
        this.clientW = window.innerWidth;
        this.clientH = window.innerHeight;
		//Присваиваем значения человека (gender/ageFrom/ageTo)
		this.human = this.$route.query

		this.getGenders().then(() => {
			let maleId = this.gendersList.find((x) => x.gender === 1).id;

			this.$http
				.get(`${this.apiUrl}BodyTree/GetPropertyTreeViewV2?humanId=${maleId}`)
				.then(response => {
                    for (let i = 0; i < response.data.filter((x) => x.name === 'Система психических функций').length; i++) {
                        for (let j = 0; j < response.data.filter((x) => x.name === 'Система психических функций')[i].propertyGroups.length; j++) {
                            for (let k = 0; k < response.data.filter((x) => x.name === 'Система психических функций')[i].propertyGroups[j].indicators.length; k++) {
                                response.data.filter((x) => x.name === 'Система психических функций')[i].propertyGroups[j].indicators[k].propertyDataList = response.data.filter((x) => x.name === 'Система психических функций')[i].propertyGroups[j].indicators[k].propertyDataList.sort((a, b) => a.ageOnMonth - b.ageOnMonth);
                            }
                        }
                    }

					this.maleTreeView = this.getTreeView(response.data);
				})

			let femaleId = this.gendersList.find((x) => x.gender === 2).id;

			this.$http
				.get(`${this.apiUrl}BodyTree/GetPropertyTreeViewV2?humanId=${femaleId}`)
				.then(response => {
                    for (let i = 0; i < response.data.filter((x) => x.name === 'Система психических функций').length; i++) {
                        for (let j = 0; j < response.data.filter((x) => x.name === 'Система психических функций')[i].propertyGroups.length; j++) {
                            for (let k = 0; k < response.data.filter((x) => x.name === 'Система психических функций')[i].propertyGroups[j].indicators.length; k++) {
                                response.data.filter((x) => x.name === 'Система психических функций')[i].propertyGroups[j].indicators[k].propertyDataList = response.data.filter((x) => x.name === 'Система психических функций')[i].propertyGroups[j].indicators[k].propertyDataList.sort((a, b) => a.ageOnMonth - b.ageOnMonth);
                            }
                        }
                    }

                    this.femaleTreeView = this.getTreeView(response.data);
				})
		})

		this.mobile = window.document.documentElement.clientWidth <= 960;

		if (this.mobile) {
			this.descriptionLinkText = 'Описание';
		}
	}
};
</script>



<style>
.speed-dial-desktop .v-speed-dial__list {
  align-items: flex-start !important;
  justify-content: left !important;
}

.speed-dial-mobile .v-speed-dial__list {
	left: calc(-100vw + 60px) !important;
	align-items: end !important;
	justify-content: left !important;
}
</style>

<style lang="scss" scoped>
@import "~@/scss/vars.scss";

.activeBtn {
    filter: opacity(1)!important;
}
.activeBtn:before {
    content:'';
	position: absolute;
	top: 0;
	left: 0;
	width: 0;
	height: 100%;
	background: rgba(255, 255, 255, 0.154);
    transition: all 1s ease;
}
.activeBtn:before {
	width: 100%;
}

.block-split {
    display: flex;
}
.three-btn {
    width: 20%;
    height: 100vh;
    background: rgba(0, 30, 70, 1);
}
.height-btn-guest {
    filter: opacity(0.5);
    border: 1px solid rgba(36,106,169,0.5);
    cursor: pointer;
    height: 33.3%;
    color: rgba(129,182,228,0.95);
}
.height-btn-metodist {
    filter: opacity(0.5);
    border: 1px solid rgba(36,106,169,0.5);
    cursor: pointer;
    height: 25%;
    color: rgba(129,182,228,0.95);
}
.height-btn-split-g {
    filter: opacity(0.5);
    border: 1px solid rgba(36,106,169,0.5);
    cursor: pointer;
    height: 33.3%;
    color: rgba(129,182,228,0.95);
}
.height-btn-split-m {
    filter: opacity(0.5);
    border: 1px solid rgba(36,106,169,0.5);
    cursor: pointer;
    height: 25%;
    color: rgba(129,182,228,0.95);
}
.height-btn-split-m:before {
	content:'';
	position: absolute;
	top: 0;
	left: 0;
	width: 0;
	height: 100%;
	background: rgba(255, 255, 255, 0.154);
	transition: all 1s ease;
}
.height-btn-split-g:before {
	content:'';
	position: absolute;
	top: 0;
	left: 0;
	width: 0;
	height: 100%;
	background: rgba(255, 255, 255, 0.154);
	transition: all 1s ease;
}
.height-btn-split-m:hover:before {
	width: 100%;
}
.height-btn-split-g:hover:before {
	width: 100%;
}
.btn-split-img {
    width: 100%;
    height: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.btn-split-header {
    // border-top: 1px solid rgba(36,106,169,0.5);
    height: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.header {
  position: absolute;
  top: 0;
  left: 75px;
  width: calc(80% - 60px);
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;
  height: 100px;
  margin: 0 0 -100px;
  z-index: 10;
  background: transparent;
}

.header__text {
  font-weight: 700;
  font-size: 26px;
  line-height: 18px;
  color: #fff;
}

.header__left {
  justify-content: flex-start;
}

.header__white {
  background-color: rgba(255, 255, 255, 0.97);
}

.header__white .header__text {
  padding: 0 0 0 32px;
  color: #000;
}

.header__arrow::before {
  content: "";
  position: absolute;
  left: 20px;
  display: flex;
  width: 12px;
  height: 20px;
  background: url("~@/assets/img/white-back-arrow.svg") no-repeat;
}

.header-row {
	margin: 0;
}

.header-row-mobile {
	display: none;
}

.main {
  display: flex;
  flex-direction: row;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.main-content {
  display: flex;
  flex-flow: column;
  flex-grow: 1;
  margin: 0;
  padding: 0;
  min-height: 100vh;
  // background: $white;
  overflow: hidden;
}

.links {
  .link {
    font-size: 18px;
    font-weight: bold;
    border-bottom: 4px solid transparent;
    text-decoration: none;
    margin-right: 20px;

    &.router-link-active {
      color: $green;
      border-color: $green;
    }
  }
}

.block-div {
    width: 80%;
    height: 100vh;
}

#svgElem {
  width: 100%;
  height: 100vh;
  // margin: 0 0 0 75px;
  background: rgba(0, 30, 70, 1);
  // background-url: url('~/assets/image/image4.svg');
  // background-image: url('../assets/image/image4.svg');
}

.header-invisible-back {
  display: flex;
  width: 100%;
  height: 100px;
  margin: 0 0 -100px;
  z-index: 11;
  background: transparent;
}

@media screen and (min-width: 1100px) {
	.btn-split-header {
    	font-size: 18px;
	}
}

@media screen and (min-width: 1200px) {
	.btn-split-header {
    	font-size: 20px;
	}
}

@media screen and (max-width: 960px) {
	.main {
		background: rgba(0, 30, 70, 1);
		background-image: url("../../assets/img/login-lines.png");
		background-repeat: no-repeat;
		background-size: 100%;
  	}

	.main-content {
		height: calc(100vh - 48px);
	}

	#svgElem {
		position: absolute;
		top: -10px;
		left: -20%;
		box-sizing: content-box;
		width: 120%;
		height: calc(100vh - 48px);
		// margin: 0 0 20px;
		overflow: hidden;
		background: transparent;
	}

	.header {
		left: 0;
		width: 100%;
		height: 48px;
		margin: 0;
		background: #04192d;
	}

	.header__white .header__text,
	.header__text {
		margin: 0 0.25rem;
		padding-bottom: 5px;
		font-weight: 400;
		font-size: 18px;
		line-height: 22px;
		color: #fff;
	}

	.header-row,
	.three-btn {
		display: none;
	}

	.header-row-mobile {
		display: flex;
		height: 48px;
		margin: 0;
		align-content: center;

		& div {
			height: 48px;
		}
	}

	.burger {
		margin-top: 0.25rem;
		margin-left: 0.25rem;
	}

	.student-menu-mobile {
		display: none;
		max-width: 350px;
		height: calc(100vh - 48px - 48px);
		overflow: auto;
		position: absolute;
		top: 48px;
		left: 0;
		right: 17%;
		z-index: 20;
		background-color: #04192d;
		border-top: 1px solid #9D30FF;

		&.opened {
			display: block;
		}

		ul {
			padding: 24px;
			list-style-type: none;

			li {
				margin-bottom: 1.5rem;

				&:last-child {
					margin-bottom: 0;
				}

				.section-item {
					display: flex;

					&.selected:before {
						position: absolute;
						display: block;
						height: 2.7rem;
						width: .75rem;
						border-radius: .75rem;
						background-color: #9D30FF;
						content: "";
						left: -6px;
					}
				}

				.section-icon {
					width: 32px;
					height: 32px;
					margin: 0.3rem;
				}

				.section-name {
					color: #7AAEDC;
					padding: 0.5rem;
				}
			}
		}
	}

	.speed-dial-mobile {
		top: 20px;
	}

	.block-split {
		margin-top: 48px;
	}

	.block-div {
		width: 100%;
		height: calc(100vh - 48px);
	}

	.v-toolbar__title {
		font-size: 1rem;
		font-weight: 500;
	}
}
</style>
